import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("dpa_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem("dpa_token"))
      .finally(() => setLoading(false));
  }, []);

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("dpa_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("dpa_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("dpa_token");
    setUser(null);
  };

  const setSession = ({ token, user }) => {
    localStorage.setItem("dpa_token", token);
    setUser(user);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, signup, login, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
